import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "command-info-content" }
const _hoisted_2 = {
  key: 0,
  class: "example"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", {
    class: "command-item-wrapper",
    onMouseenter: _cache[1] || (_cache[1] = $event => ($data.self_active = true)),
    onMouseleave: _cache[2] || (_cache[2] = $event => ($data.self_active = false))
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent($props.standalone ? 'div' : 'el-dropdown-item'), {
      ref: "item",
      class: _normalizeClass(["command-item", {active: $options.c_active}])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          icon: $props.item.icon,
          size: "1.6rem",
          stroke: "var(--brand-900)",
          "stroke-width": "1"
        }, null, 8 /* PROPS */, ["icon"]),
        _createVNode(_component_Ellipsis, { class: "title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.item.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        ($props.item.example || $props.item.description)
          ? (_openBlock(), _createBlock(_component_Popover, {
              key: 0,
              trigger: "hover",
              placement: "right",
              "popper-class": "command-item-info",
              mask: _ctx.$responsive.mobile,
              "z-index": _ctx.$responsive.mobile ? 3000 : undefined,
              "show-arrow": false,
              "show-after": 150,
              teleported: true,
              persistent: false,
              "popper-options": {modifiers: [{name: 'offset', options: {offset: [0, 30]}}]}
            }, {
              reference: _withCtx(() => [
                _createVNode(_Transition, null, {
                  default: _withCtx(() => [
                    (_ctx.$responsive.mobile || $options.c_active)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "reference",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_Icon, {
                            class: "info",
                            icon: "info",
                            size: _ctx.$responsive.mobile ? '1.4rem' : '1.2rem',
                            stroke: "var(--brand-400)",
                            "stroke-width": "1"
                          }, null, 8 /* PROPS */, ["size"])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  ($props.item.example)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Example: " + _toDisplayString($props.item.example), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($props.item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.item.description), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["mask", "z-index"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"]))
  ], 32 /* NEED_HYDRATION */))
}